/*
 * Caroselli prodotto stile Deghi sopra lo <slider-component> di Trade:
 * - pulsanti e pallini spostano di una pagina intera (le card visibili);
 * - i pallini indicano la pagina e ci si salta cliccandoli;
 * - con una sola pagina la navigazione sparisce.
 * Si ricalcola quando cambia la larghezza (2 card su mobile, 5 su desktop…).
 */
(() => {
  function migliora(carosello) {
    if (carosello.dataset.gmCarosello) return;
    carosello.dataset.gmCarosello = 'pronto';

    const pista = carosello.querySelector('[id^="Slider-"]');
    const punti = carosello.querySelector('.gm-carosello__punti');
    const prec = carosello.querySelector('button[name="previous"]');
    const succ = carosello.querySelector('button[name="next"]');
    if (!pista || !punti || !prec || !succ) return;

    const etichetta = punti.dataset.etichetta || '[n]';
    const ridotto = window.matchMedia('(prefers-reduced-motion: reduce)');

    function misure() {
      const elementi = Array.from(carosello.querySelectorAll('[id^="Slide-"]')).filter((el) => el.clientWidth > 0);
      const passo = elementi.length > 1 ? elementi[1].offsetLeft - elementi[0].offsetLeft : pista.clientWidth;
      // N card occupano N·passo − spazio: si aggiunge lo spazio tra le card prima di dividere.
      const spazio = elementi.length ? Math.max(0, passo - elementi[0].offsetWidth) : 0;
      const perPagina = Math.max(1, Math.floor((pista.clientWidth + spazio + 1) / Math.max(1, passo)));
      return { elementi, passo, perPagina, pagine: Math.max(1, Math.ceil(elementi.length / perPagina)) };
    }

    function paginaAttiva() {
      const { passo, perPagina, pagine } = misure();
      let attiva = Math.round(pista.scrollLeft / Math.max(1, passo) / perPagina);
      if (pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2) attiva = pagine - 1;
      return Math.min(pagine - 1, Math.max(0, attiva));
    }

    function vaiAllaPagina(pagina) {
      const { passo, perPagina, pagine } = misure();
      const destinazione = Math.min(pagine - 1, Math.max(0, pagina));
      pista.scrollTo({ left: destinazione * perPagina * passo, behavior: ridotto.matches ? 'auto' : 'smooth' });
    }

    // Pulsanti per pagine, come i pallini. Trade sposta di «step» card dalla posizione
    // corrente: con un numero dispari di card, tornando indietro dall'ultima pagina
    // (che si sovrappone alla penultima) le pagine restavano sfasate di una card.
    // In cattura sul pulsante: parte prima del gestore di Trade e lo ferma.
    [prec, succ].forEach((pulsante) => {
      pulsante.addEventListener(
        'click',
        (evento) => {
          evento.preventDefault();
          evento.stopImmediatePropagation();
          vaiAllaPagina(paginaAttiva() + (pulsante === succ ? 1 : -1));
        },
        true
      );
    });

    function evidenzia() {
      const attiva = paginaAttiva();
      Array.from(punti.children).forEach((punto, i) => {
        if (i === attiva) punto.setAttribute('aria-current', 'true');
        else punto.removeAttribute('aria-current');
      });
    }

    function disegna() {
      const { elementi, perPagina, pagine } = misure();
      // Pulsanti centrati sull'immagine della prima card visibile.
      const media = elementi[0]?.querySelector('.card__inner');
      if (media) {
        const centro = media.getBoundingClientRect().top - carosello.getBoundingClientRect().top + media.offsetHeight / 2;
        carosello.style.setProperty('--gm-centro', `${Math.round(centro)}px`);
      }
      prec.dataset.step = perPagina;
      succ.dataset.step = perPagina;
      carosello.classList.toggle('gm-carosello--una-pagina', pagine <= 1);

      if (punti.children.length !== pagine) {
        punti.replaceChildren();
        for (let i = 0; i < pagine; i += 1) {
          const punto = document.createElement('button');
          punto.type = 'button';
          punto.className = 'gm-carosello__punto';
          punto.setAttribute('aria-label', etichetta.replace('[n]', i + 1));
          punto.addEventListener('click', () => vaiAllaPagina(i));
          punti.append(punto);
        }
      }
      evidenzia();
    }

    // Timer e non requestAnimationFrame: rAF si ferma nelle schede non visibili.
    let attesa;
    pista.addEventListener(
      'scroll',
      () => {
        clearTimeout(attesa);
        attesa = setTimeout(evidenzia, 60);
      },
      { passive: true }
    );
    new ResizeObserver(() => disegna()).observe(pista);
    disegna();
  }

  function avvia() {
    document.querySelectorAll('slider-component.gm-carosello').forEach(migliora);
  }

  avvia();
  // L'editor del tema ricarica le sezioni senza ricaricare la pagina.
  document.addEventListener('shopify:section:load', avvia);
  // I prodotti correlati arrivano dopo il caricamento: product-recommendations
  // riscrive il proprio contenuto quando la sezione entra nello schermo.
  document.querySelectorAll('product-recommendations').forEach((contenitore) => {
    new MutationObserver(avvia).observe(contenitore, { childList: true });
  });
})();
